import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import SelectOrganization from "components/SelectOrganization";
import { useIntl } from "react-intl";
import persistanceStore from "stores/persistanceStore";

type SkuContentFilterProps = {
  searchTerm: string;
  ownerOrganizationId?: string | undefined;
  minPrice: number | undefined;
  maxPrice: number | undefined;
};

export function SkuContentFilter({
  searchTerm,
  ownerOrganizationId,
  minPrice,
  maxPrice,
}: SkuContentFilterProps) {
  const { formatMessage: t } = useIntl();

  return (
    <Accordion sx={{ mb: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{t({ id: "filtersLabel" })}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={1}>
          <Grid container spacing={2}>
            <Grid item sm={12} md={5}>
              <TextField
                fullWidth
                variant="outlined"
                value={searchTerm ?? ""}
                placeholder={t({ id: "searchPlaceholder" })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          persistanceStore.update((s) => {
                            s.skuContentSearchTerm = "";
                          })
                        }
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) =>
                  persistanceStore.update((s) => {
                    s.skuContentSearchTerm = e.target.value;
                  })
                }
              />
            </Grid>

            <Grid item sm={12} md={3}>
              <SelectOrganization
                value={ownerOrganizationId}
                onChange={(id) =>
                  persistanceStore.update((s) => {
                    s.skuContentOwnerOrganizationId = id;
                  })
                }
                textFieldProps={{
                  variant: "outlined",
                }}
                label={t({ id: "ownerOrganization" })}
              />
            </Grid>

            <Grid item sm={6} md={2}>
              <TextField
                fullWidth
                type="number"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoneyIcon />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                value={minPrice || ""}
                placeholder={t({ id: "skuContentMinPricePlaceholder" })}
                onChange={(e) =>
                  persistanceStore.update((s) => {
                    s.skuContentMinPrice = parseInt(e.target.value);
                  })
                }
              />
            </Grid>

            <Grid item sm={6} md={2}>
              <TextField
                fullWidth
                type="number"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoneyIcon />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                value={maxPrice || ""}
                placeholder={t({ id: "skuContentMaxPricePlaceholder" })}
                onChange={(e) =>
                  persistanceStore.update((s) => {
                    s.skuContentMaxPrice = parseInt(e.target.value);
                  })
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
